import { faBars, faUser } from "@fortawesome/free-solid-svg-icons";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu } from "primereact/menu";
import { useRef } from "react";

import { useLocale } from "../stores/locale";
import { PrimeButton } from "./prime/button";
import { PrimeMenu } from "./prime/menu";

export function TopMenu() {
  const menuLeft = useRef<Menu | null>(null);
  const t = useLocale((state) => state.locale);

  return (
    <div className="bg-blue-400 sticky top-0 z-10">
      <div className="lg:container flex justify-end">
        <PrimeMenu
          ref={menuLeft}
          popup
          id="popup_menu_left"
          model={[
            {
              label: t.profile.title,
              url: "/profile",
              icon: <FontAwesomeIcon icon={faUser} />,
            },
            {
              label: t.logout,
              url: "/logout",
              icon: <FontAwesomeIcon icon={faSignOut} />,
            },
          ]}
        />
        <PrimeButton
          aria-haspopup
          aria-controls="popup_menu_left"
          className="!rounded-none"
          icon={<FontAwesomeIcon icon={faBars} />}
          onClick={(event) => menuLeft.current?.toggle(event)}
        />
      </div>
    </div>
  );
}
